const movieDBSite = 'https://project-react-ts-coral.vercel.app/';
const movieGitHub = 'https://github.com/32Valik92/project_react-ts';

const superHeroesLinks = {
   superHeroesSite: 'https://github.com/32Valik92/superheroes',
   superHeroesGitHub: 'https://github.com/32Valik92/superheroes'
};

const WordsAPIFormLinks = {
   WordsAPIFormSite: 'https://dictionary-form-search.vercel.app',
   WordsAPIFormGitHub: 'https://github.com/32Valik92/dictionary_form_search'
};

export {
   movieDBSite,
   movieGitHub,
   superHeroesLinks,
   WordsAPIFormLinks
};